import { createFileRoute } from "@tanstack/react-router";
import { categoryHead } from "@/lib/seo";
import { CategoryHero } from "@/components/CategoryHero";
import { ProductGrid } from "@/components/ProductGrid";
import { useCollectionProducts } from "@/lib/use-catalog";
import { newArrivals, lookProducts, accessories } from "@/lib/catalog";
const kimonosAsset = { url: "/img/kimonos-coverups.webp" };

export const Route = createFileRoute("/kimonos")({
  head: () =>
    categoryHead({
      path: "/kimonos",
      title: "Kimonos & Cover-ups Femme au Maroc | SUNSET",
      description:
        "Kimonos de plage, voiles légers et cover-ups imprimés. Dès 399 DH, livraison partout au Maroc et paiement à la livraison.",
      socialDescription:
        "Kimonos et cover-ups en voile léger SUNSET Concept Store. Paiement à la livraison partout au Maroc.",
      name: "Kimonos & Cover-ups",
      image: "/og/kimonos.jpg",
      imageAlt: "Kimonos et cover-ups légers Sunset Concept Store",
      products: localProducts,
    }),
  component: KimonosPage,
});

const localProducts = [...newArrivals, ...lookProducts, ...accessories].filter(
  (p) => p.category === "Kimonos",
);

function KimonosPage() {
  const products = useCollectionProducts("/kimonos", localProducts, /kimono/i);
  return (
    <>
      <CategoryHero
        image={kimonosAsset.url}
        imageAlt="Kimonos et cover-ups légers Sunset Concept Store"
        eyebrow="Collection"
        title="Kimonos & Cover-ups"
        subtitle="Voiles, lin léger et imprimés pour enjoliver vos moments au soleil."
        imagePosition="sm:object-[50%_55%]"
      />
      <ProductGrid
        products={products}
        placeholderCount={8}
        title="Nos Kimonos"
        eyebrow="Nouveautés"
        subtitle="Des coupes fluides et des matières naturelles pour un confort estival."
        emptyMessage={
          <>
            <p className="text-sm text-muted-foreground sm:text-base">
              La collection Kimonos & Cover-ups arrive très bientôt.
            </p>
            <p className="label-xs mt-3 text-accent">Revenez très vite</p>
          </>
        }
      />
    </>
  );
}
